import { useEffect } from 'react'
import { useForm } from 'react-hook-form'

import { ButtonRounded } from '@apps-common/components/elements/button'
import { CheckboxInputSM, FieldErrorMessage } from '@apps-common/components/elements/form'
import { ModalBody, ModalContainer, ModalFooter, ModalHeader, ModalHeaderContainer } from '@apps-common/components/modals/modal'
import { ModalDismiss } from '@apps-common/config/modal'

const PIN_UNIT_OPTIONS = [
  { label: 'Pin to my account', value: 'Account', description: 'Visible to only you on your account.' },
  { label: 'Pin to my company', value: 'Company', description: 'Visible to all users in my company.' }
]

type FormInputs = {
  deviceVisibility: string
}

export const PinUnitModal = ({
  onDismiss,
  componentProps
}: {
  onDismiss: (data?: string | null | undefined | number, role?: string) => void
  componentProps: any
}) => {
  const {
    register,
    handleSubmit,
    watch,
    setValue,
    formState: { errors }
  } = useForm<FormInputs>({ mode: 'onSubmit' })

  useEffect(() => {
    register('deviceVisibility', {
      required: {
        value: true,
        message: 'Select an option to continue'
      }
    })
  }, [])

  const onSubmit = async (values: FormInputs) => onDismiss(values.deviceVisibility, ModalDismiss.Confirm)

  const deviceVisibilityValue = watch('deviceVisibility')

  return (
    <ModalContainer classes='!items-center' innerClasses='rounded-3xl !min-h-0 !h-[280px] !min-w-[min(90%,0px)] !w-[320px]'>
      <ModalHeaderContainer>
        <ModalHeader subtitle='Update' title='Pin to dashboard' />
      </ModalHeaderContainer>
      <ModalBody classes='!pt-[80px] !pb-[120px]'>
        <div className='relative top-[-12px] pb-[5px]'>
          <FieldErrorMessage classes='absolute !py-0 !pb-2' errors={errors?.deviceVisibility} />
        </div>
        <form noValidate id='pin-unit-dashboard-form' onSubmit={handleSubmit(onSubmit)}>
          {PIN_UNIT_OPTIONS.map((o) => (
            <div key={`pin-unit-option-${o.value}`}>
              <CheckboxInputSM
                label={o.label}
                registration={{
                  onChange: (e: any) => {
                    if (e?.target?.checked) {
                      setValue('deviceVisibility', o.value, { shouldValidate: true })
                    }
                  },
                  checked: o.value === deviceVisibilityValue
                }}
                className='mb-4'
                description={o.description}
              />
            </div>
          ))}
        </form>
      </ModalBody>
      <ModalFooter>
        <div className='w-full flex items-center justify-start gap-2'>
          <ButtonRounded
            type='submit'
            form='pin-unit-dashboard-form'
            text='Done'
            loading={false}
            className='action-info !grow !w-auto !min-w-0'
          />
          <ButtonRounded
            type='button'
            text='Cancel'
            loading={false}
            className='action-neutral !grow !w-auto !min-w-0'
            callback={() => onDismiss(null, ModalDismiss.Cancel)}
          />
        </div>
      </ModalFooter>
    </ModalContainer>
  )
}
